import React from 'react';
import { IonContent, IonPage } from '@ionic/react';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';

const NotFound: React.FC = () => (
  <IonPage>
    <IonContent>
      <SiteNav current="" />
      <main className="page">
        <p className="prompt-line" style={{ fontSize: '1rem' }}>
          <em>{typeof window !== 'undefined' ? window.location.pathname.slice(1) : 'unknown'}</em>
        </p>
        <h1 className="display" style={{ fontSize: 'clamp(1.6rem, 4vw, 2.4rem)' }}>
          command not found<span className="cursor" />
        </h1>
        <p className="lede">
          zsh: no such page. The file you are looking for was moved, deleted, or never existed.
        </p>
        <div className="btn-row">
          <a className="btn btn--primary" href="/home">cd ~</a>
          <a className="btn btn--ghost" href="/projects">ls ~/projects</a>
        </div>
        <SiteFooter />
      </main>
    </IonContent>
  </IonPage>
);

export default NotFound;
